import { PatientGroupAssignmentGroup } from '@dreryk/egabinet-patient-frontend-api';

import { HexColorDot, HexColorDotSize, StyledFlex, TooltipLabel } from '@dreryk/react-components';

import { translationKeys } from './translations';

type PatientGroupsTooltipContentProps = {
   patientGroups: PatientGroupAssignmentGroup[];
};

export const PatientGroupsTooltipContent = (props: PatientGroupsTooltipContentProps): JSX.Element => {
   return (
      <StyledFlex direction={'column'} gap={4}>
         <TooltipLabel label={translationKeys.patientGroups} />
         {props.patientGroups.map((group) => (
            <StyledFlex key={group.id} gap={4} alignItems={'center'}>
               <HexColorDot
                  testId={group.id}
                  color={group.primaryColor.asHexString()}
                  darkModeColor={group.darkModeColor?.asHexString()}
                  size={HexColorDotSize.SMALL}
               />
               {group.name}
            </StyledFlex>
         ))}
      </StyledFlex>
   );
};
